import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 8,
    [FULL_HD]: 8,
  },
  search: {
    [HD]: 5,
    [FULL_HD]: 5,
  },
};

export const iconSizes = {
  [HD]: {
    h: 80,
    // width should be 1.6 * height
    w: 112,
  },
  [FULL_HD]: {
    h: 96,
    // width should be 1.6 * height
    w: 144,
  },
};
